function injectStyle (ssrContext) {
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-5c271fff\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../node_modules/string-replace-webpack-plugin/loader.js?id=csplt5ikear!../../node_modules/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./PetitionEpbc.vue")
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-5c271fff\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!../../node_modules/string-replace-webpack-plugin/loader.js?id=csplt5ikear!../../node_modules/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./PetitionEpbc.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!../../node_modules/string-replace-webpack-plugin/loader.js?id=csplt5ikear!../../node_modules/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./PetitionEpbc.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5c271fff\",\"hasScoped\":true}!../../node_modules/vue-loader/lib/selector?type=template&index=0!../../node_modules/string-replace-webpack-plugin/loader.js?id=csplt5ikear!../../node_modules/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./PetitionEpbc.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c271fff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/PetitionEpbc.vue
// module id = 244
// module chunks = 0